export enum yesOrNo {
    YES = "y", 
    NO = "n"
}